(function () {
	'use strict';
	angular.module('app.supplyChain')
		.controller('deliveryScoreController', deliveryScoreController);

	deliveryScoreController.$inject = ['$scope', '$timeout', 'supplierPerformanceSummaryService'];

	function deliveryScoreController($scope, $timeout, supplierPerformanceSummaryService) {
		function getSupplierPerformanceBuckets(data, noOfMonths) {
			var buckets = {
				'delPerfMonthBucket': [],
				'delPerf3MonthRollingBucket': [],
				'delPerfMonthBucketRnk': []
			};
			for (var i = 0; i < noOfMonths; i++) {
				buckets['delPerfMonthBucket'].push(data['delPerfMonthBucket' + (i + 1)] || 'null');
				buckets['delPerf3MonthRollingBucket'].push(data['delPerf3MonthRollingBucket' + (i + 1)] || 'null');
				buckets['delPerfMonthBucketRnk'].push(data['delPerfMonthBucket' + (i + 1) + 'Rnk'] || 'null');
			}
			return buckets;
		}

		function getDeliveryScoreDataBySupplier(factoryNdxs, supplierNdxs) {
			supplierPerformanceSummaryService.getDeliveryScoreDataBySupplier(factoryNdxs, supplierNdxs).then(function (data) {
				$scope.loading = false;
				$scope.initialLoad = false;

				if (!data) {
					$scope.empty = true;
				} else {
					var buckets = getSupplierPerformanceBuckets(data, 12);
					$scope.monthlyValues = _.reverse(buckets['delPerfMonthBucket']);
					$scope.threeMonthAvgValues = _.reverse(buckets['delPerf3MonthRollingBucket']);
					$scope.monthlyRank = _.reverse(buckets['delPerfMonthBucketRnk']);
					$scope.noPerformanceData = _.reject($scope.monthlyValues, _.isNumber).length == 12 &&
						_.reject($scope.threeMonthAvgValues, _.isNumber).length == 12;
					$scope.$broadcast('supplierDeliveryScoresChartReady', null);
				}
			});
		}

		function init() {
			if (incomingData.factory && incomingData.supplierNdxs && incomingData.isRemote) {
				getDeliveryScoreDataBySupplier(incomingData.factory, incomingData.supplierNdxs);
			} else {
				$timeout(function () {
					$scope.$broadcast('supplierDeliveryScoresChartReady', null);
				});				
			}
		}

		init();
	}
})();
